export default __webpack_public_path__ + "static/media/chat.b4a1867b.svg";